import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { ProcessAttachmentsAggregate } from '@Purchasing/Domain/Model/PurchaseProcess'
import { useCallback, useEffect, useState } from 'react'

export const useProcessAttachments = (processId?: string) => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseGetProcessAttachments
    )
    const [data, setData] = useState<ProcessAttachmentsAggregate | null>(null)
    const [loading, setLoading] = useState<boolean>(false)

    const load = useCallback(async () => {
        if (!processId) return
        setLoading(true)
        try {
            const result = await useCase.execute(processId)
            setData(result)
        } catch {
            setData(null)
        }
        setLoading(false)
    }, [useCase, processId])

    useEffect(() => {
        load()
    }, [load])

    return { data: data ?? EMPTY, loading, reload: load }
}

const EMPTY: ProcessAttachmentsAggregate = {
    process: [],
    quotes: [],
    purchase: [],
    payments: [],
}